import { render, staticRenderFns } from "./CorOuRacaCard.vue?vue&type=template&id=38d50633&scoped=true"
import script from "./CorOuRacaCard.vue?vue&type=script&lang=js"
export * from "./CorOuRacaCard.vue?vue&type=script&lang=js"
import style0 from "./CorOuRacaCard.vue?vue&type=style&index=0&id=38d50633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d50633",
  null
  
)

export default component.exports